"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _commonPricings = require("./commonPricings");
var _excluded = ["repairBonus"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } // *** Version: 13 ***
// when adding new fields do not forget to update pricingItems in locales with translations
function communLeatherGoodsFinish(slug) {
  return {
    name: 'Finition',
    slug: 'finish',
    items: [{
      name: 'Finition supplémentaire - Simple',
      prices: {
        SIMPLE: 10,
        COMPLEX: 10
      },
      id: "13.".concat(slug, "-finish-3")
    }, {
      name: 'Finition supplémentaire - Standard',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: "13.".concat(slug, "-finish-4")
    }, {
      name: 'Finition supplémentaire - Complexe',
      prices: {
        SIMPLE: 50,
        COMPLEX: 50
      },
      id: "13.".concat(slug, "-finish-5")
    }, {
      name: 'Frais de déplacement - Matière',
      prices: {
        SIMPLE: 25,
        COMPLEX: 25
      },
      id: "13.".concat(slug, "-finish-8")
    }, {
      name: 'Ajustement sur-mesure (1h)',
      prices: {
        SIMPLE: 80,
        COMPLEX: 80
      },
      id: "13.".concat(slug, "-finish-6")
    }, {
      name: 'Perçage de trou',
      prices: {
        SIMPLE: 3,
        COMPLEX: 3
      },
      id: "13.".concat(slug, "-finish-7")
    },
    // DEPRECATED
    {
      name: 'Finition supplémentaire - Simple',
      prices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      id: "13.".concat(slug, "-finish-2"),
      hidden: true
    }, {
      name: 'Recollage (x1)',
      prices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      id: "13.".concat(slug, "-finish-1"),
      hidden: true
    }]
  };
}
function generateLeatherGoodsAccePrice(slug) {
  return {
    categories: [{
      name: 'Entretenir',
      slug: 'prevent',
      subCategories: [{
        name: 'Soin du cuir',
        slug: 'leather_care',
        items: [{
          name: 'Nettoyage & Soin complet',
          prices: {
            SIMPLE: 25,
            COMPLEX: 30
          },
          id: "13.".concat(slug, "-prevent-1"),
          atShop: true
        }, {
          name: 'Rénovation standard - Petite maroquinerie',
          prices: {
            SIMPLE: 60,
            COMPLEX: 60
          },
          id: "13.".concat(slug, "-recolor-1"),
          atShop: true
        }, {
          name: 'Rénovation complexe - Petite maroquinerie',
          prices: {
            SIMPLE: 60,
            COMPLEX: 60
          },
          id: "13.".concat(slug, "-recolor-2")
        }]
      }, {
        name: 'Soins complémentaires',
        slug: 'additional_care',
        items: [{
          name: 'Cirage simple',
          prices: {
            SIMPLE: 15,
            COMPLEX: 15
          },
          id: "13.".concat(slug, "-prevent-2")
        }, {
          name: 'Imperméabilisation',
          prices: {
            SIMPLE: 20,
            COMPLEX: 20
          },
          id: "13.".concat(slug, "-prevent-3")
        }, {
          name: 'Nettoyage - Bijouterie / pièces métalliques',
          prices: {
            SIMPLE: 30,
            COMPLEX: 30
          },
          id: "13.".concat(slug, "-prevent-5")
        },
        // DEPRECATED
        {
          name: 'Perçage de trou',
          prices: {
            SIMPLE: 3,
            COMPLEX: 3
          },
          id: "13.".concat(slug, "-prevent-4"),
          hidden: true
        }]
      }]
    }, {
      name: 'Réparer',
      slug: 'cure',
      subCategories: [{
        name: 'Déchirures / trous',
        slug: 'tears',
        items: [{
          name: 'Craquelure / éraflure',
          prices: {
            SIMPLE: 10,
            COMPLEX: 10
          },
          id: "13.".concat(slug, "-cure-23")
        }, {
          name: 'Déchirure - Petite (0 à 10 cm)',
          prices: {
            SIMPLE: 15,
            COMPLEX: 15
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-24")
        }, {
          name: 'Déchirure - Moyenne (10 à 20 cm)',
          prices: {
            SIMPLE: 20,
            COMPLEX: 20
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-25")
        }, {
          name: 'Trou (1 à 2 cm)',
          prices: {
            SIMPLE: 40,
            COMPLEX: 40
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-26")
        }, {
          name: 'Coins abîmés (x4)',
          prices: {
            SIMPLE: 40,
            COMPLEX: 40
          },
          id: "13.".concat(slug, "-cure-27")
        }, {
          name: 'Bord abîmé - Simple (anciennement : biais craquelé / abîmé)',
          prices: {
            SIMPLE: 40,
            COMPLEX: 40
          },
          id: "13.".concat(slug, "-cure-34")
        }, {
          name: 'Bord abîmé - Complexe',
          prices: {
            SIMPLE: 70,
            COMPLEX: 70
          },
          id: "13.".concat(slug, "-cure-37")
        }, {
          name: 'Couture décousue (0 à 5 cm)',
          prices: {
            SIMPLE: 15,
            COMPLEX: 15
          },
          id: "13.".concat(slug, "-cure-28")
        }, {
          name: 'Couture décousue (5 à 10 cm)',
          prices: {
            SIMPLE: 20,
            COMPLEX: 20
          },
          id: "13.".concat(slug, "-cure-29"),
          atShop: true
        }, {
          name: 'Couture décousue (10 à 40 cm)',
          prices: {
            SIMPLE: 30,
            COMPLEX: 30
          },
          id: "13.".concat(slug, "-cure-30")
        }, {
          name: 'Couture décousue (> 40 cm)',
          prices: {
            SIMPLE: 60,
            COMPLEX: 60
          },
          id: "13.".concat(slug, "-cure-31")
        }, {
          name: 'Couture décousue - Main / sellier - Simple',
          prices: {
            SIMPLE: 25,
            COMPLEX: 25
          },
          id: "13.".concat(slug, "-cure-32")
        }, {
          name: 'Couture décousue - Main / sellier - Standard',
          prices: {
            SIMPLE: 50,
            COMPLEX: 50
          },
          id: "13.".concat(slug, "-cure-35")
        }, {
          name: 'Couture décousue - Main / sellier - Complexe',
          prices: {
            SIMPLE: 100,
            COMPLEX: 100
          },
          id: "13.".concat(slug, "-cure-36")
        }, {
          name: 'Ceinture - Changement intégral',
          prices: {
            SIMPLE: 120,
            COMPLEX: 120
          },
          id: "13.".concat(slug, "-cure-33")
        },
        // DEPRECATED
        {
          name: 'Déchirure : réparation avec pose d‘empiècement',
          prices: {
            SIMPLE: 60
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-19"),
          hidden: true
        }, {
          name: 'Bandoulière / anse / poignée / biais - Changement simple (x1)',
          prices: {
            SIMPLE: 40
          },
          id: "13.".concat(slug, "-cure-21"),
          hidden: true
        }]
      }, {
        name: 'Doublure',
        slug: 'lining',
        items: [{
          name: 'Doublure - Changement',
          prices: {
            SIMPLE: 60,
            COMPLEX: 60
          },
          id: "13.".concat(slug, "-cure-20"),
          atShop: true
        }]
      }, {
        name: 'Zips & pièces métalliques',
        slug: 'zips_metal',
        items: [{
          name: 'Zip - Changement simple',
          prices: {
            SIMPLE: 80,
            COMPLEX: 80
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-1"),
          atShop: true
        }, {
          name: 'Zip - Changement simple fourni par le client',
          prices: {
            SIMPLE: 50,
            COMPLEX: 50
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-2")
        }, {
          name: 'Zip - Changement standard',
          prices: {
            SIMPLE: 100,
            COMPLEX: 100
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-3")
        }, {
          name: 'Zip - Changement standard fourni par le client',
          prices: {
            SIMPLE: 70,
            COMPLEX: 70
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-4")
        }, {
          name: 'Zip - Changement complexe',
          prices: {
            SIMPLE: 150,
            COMPLEX: 150
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-5")
        }, {
          name: 'Zip - Changement complexe fourni par le client',
          prices: {
            SIMPLE: 90,
            COMPLEX: 90
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-6")
        }, {
          name: 'Boutons pression / rivet / oeillet (x1 bouton)',
          prices: {
            SIMPLE: 8,
            COMPLEX: 8
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-11"),
          atShop: true
        }, {
          name: 'Boutons pression / rivet / oeillet (x1 bouton suppl)',
          prices: {
            SIMPLE: 2,
            COMPLEX: 2
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-22")
        }, {
          name: 'Fermoir - Changement simple (aimant / pression / mousqueton)',
          prices: {
            SIMPLE: 40,
            COMPLEX: 40
          },
          id: "13.".concat(slug, "-cure-13")
        }, {
          name: 'Fermoir - Changement simple (aimant / pression / mousqueton) fourni par le client',
          prices: {
            SIMPLE: 30,
            COMPLEX: 30
          },
          id: "13.".concat(slug, "-cure-14")
        }, {
          name: 'Fermoir - Changement complexe (fermoir tourniquet et autres boucles)',
          prices: {
            SIMPLE: 60,
            COMPLEX: 60
          },
          id: "13.".concat(slug, "-cure-15")
        }, {
          name: 'Fermoir - Changement complexe (fermoir tourniquet et autres boucles) fourni par le client',
          prices: {
            SIMPLE: 50,
            COMPLEX: 50
          },
          id: "13.".concat(slug, "-cure-16")
        }, {
          name: 'Crochet / boucle / autre pièce métallique - Changement',
          prices: {
            SIMPLE: 30,
            COMPLEX: 30
          },
          id: "13.".concat(slug, "-cure-17")
        }, {
          name: 'Crochet / boucle / autre pièce métallique fourni par le client - Changement',
          prices: {
            SIMPLE: 20,
            COMPLEX: 20
          },
          id: "13.".concat(slug, "-cure-18")
        }, {
          name: 'Curseur',
          prices: {
            SIMPLE: 15,
            COMPLEX: 15
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-38")
        }, {
          name: 'Curseur fourni par le client',
          prices: {
            SIMPLE: 13,
            COMPLEX: 13
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-39")
        }, {
          name: 'Tirette de curseur',
          prices: {
            SIMPLE: 5,
            COMPLEX: 5
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-40")
        }, {
          name: 'Tirette de curseur fourni par le client',
          prices: {
            SIMPLE: 4,
            COMPLEX: 4
          },
          multiple: true,
          id: "13.".concat(slug, "-cure-41")
        }]
      }]
    }, communLeatherGoodsFinish(slug)]
  };
}

/* eslint max-len: 0, object-curly-newline: 0 */

/** @param { import("../entities/types").RawPricingPiece } rawLeatherGoodsPricing */
var rawLeatherGoodsPricing = [{
  name: 'Sac',
  slug: 'bag',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Prise en charge',
    slug: 'receiving',
    items: [{
      name: 'Prise en charge - Petit sac (< 25 cm)',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '13.bag-receiving-1'
    }, {
      name: 'Prise en charge - Sac moyen / tote bag (25-40 cm)',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '13.bag-receiving-2'
    }, {
      name: 'Prise en charge - Grand sac / sac de voyage (50 cm max)',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '13.bag-receiving-3'
    }]
  }, {
    name: 'Entretenir',
    slug: 'prevent',
    subCategories: [{
      name: 'Soin du cuir',
      slug: 'leather_care',
      items: [{
        name: 'Nettoyage & Soin complet - Petit sac (< 25 cm)',
        prices: {
          SIMPLE: 50,
          COMPLEX: 60
        },
        id: '13.bag-prevent-1',
        size: 'small'
      }, {
        name: 'Nettoyage & Soin complet - Sac moyen / tote bag (25-40 cm)',
        prices: {
          SIMPLE: 70,
          COMPLEX: 90
        },
        id: '13.bag-prevent-2',
        size: 'medium'
      }, {
        name: 'Nettoyage & Soin complet - Grand sac / sac de voyage (50 cm max) ',
        prices: {
          SIMPLE: 90,
          COMPLEX: 150
        },
        id: '13.bag-prevent-3',
        size: 'large'
      }, {
        name: 'Rénovation standard - Petit sac (< 25 cm)',
        prices: {
          SIMPLE: 90,
          COMPLEX: 90
        },
        id: '13.bag-recolor-11',
        size: 'small'
      }, {
        name: 'Rénovation standard - Sac moyen / tote bag (25-40 cm)',
        prices: {
          SIMPLE: 110,
          COMPLEX: 110
        },
        id: '13.bag-recolor-12',
        size: 'medium'
      }, {
        name: 'Rénovation standard - Grand sac / sac de voyage (50 cm max)',
        prices: {
          SIMPLE: 150,
          COMPLEX: 150
        },
        id: '13.bag-recolor-13',
        size: 'large'
      }, {
        name: 'Rénovation complexe - Petit sac (< 25 cm)',
        prices: {
          SIMPLE: 125,
          COMPLEX: 125
        },
        id: '13.bag-recolor-2'
      }, {
        name: 'Rénovation complexe - Sac moyen / tote bag (25-40 cm)',
        prices: {
          SIMPLE: 175,
          COMPLEX: 175
        },
        id: '13.bag-recolor-3'
      }, {
        name: 'Rénovation complexe - Grand sac / sac de voyage (50 cm max)',
        prices: {
          SIMPLE: 225,
          COMPLEX: 225
        },
        id: '13.bag-recolor-4'
      },
      // DEPRECATED
      {
        name: 'Recoloration - Partielle (x1)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.bag-recolor-1',
        hidden: true
      }]
    }, {
      name: 'Soins complémentaires',
      slug: 'additional_care',
      items: [{
        name: 'Teinture de tranche - Court',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.bag-recolor-5'
      }, {
        name: 'Teinture de tranche - Moyen',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        id: '13.bag-recolor-6'
      }, {
        name: 'Teinture de tranche - Long',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: '13.bag-recolor-7'
      }, {
        name: 'Teinture de tranche - Poignées ou anse (x2)',
        prices: {
          SIMPLE: 50,
          COMPLEX: 50
        },
        id: '13.bag-recolor-8'
      }, {
        name: 'Changement de teinte - Petit sac',
        prices: {
          SIMPLE: 155,
          COMPLEX: 155
        },
        id: '13.bag-recolor-9'
      }, {
        name: 'Changement de teinte - Sac moyen',
        prices: {
          SIMPLE: 205,
          COMPLEX: 205
        },
        id: '13.bag-recolor-10'
      }, {
        name: 'Cirage simple - Petit sac (< 25 cm)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.bag-prevent-4'
      }, {
        name: 'Cirage simple - Sac moyen / tote bag (25-40 cm)',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        id: '13.bag-prevent-6'
      }, {
        name: 'Cirage simple - Grand sac / sac de voyage (50 cm max)',
        prices: {
          SIMPLE: 50,
          COMPLEX: 50
        },
        id: '13.bag-prevent-7'
      }, {
        name: 'Imperméabiliser',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.bag-prevent-5'
      }, {
        name: 'Nettoyage - Bijouterie / pièces métalliques',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        id: '13.bag-prevent-8'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'cure',
    subCategories: [{
      name: 'Déchirures / trous',
      slug: 'tears',
      items: [{
        name: 'Craquelure / éraflure',
        prices: {
          SIMPLE: 10,
          COMPLEX: 10
        },
        id: '13.bag-cure-40'
      }, {
        name: 'Déchirure - Petite (0 à 10 cm)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        multiple: true,
        id: '13.bag-cure-41'
      }, {
        name: 'Déchirure - Moyenne (10 à 20 cm)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        multiple: true,
        id: '13.bag-cure-42'
      }, {
        name: 'Trou (1 à 2 cm)',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        multiple: true,
        id: '13.bag-cure-43'
      }, {
        name: 'Coins abîmés (x4)',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        id: '13.bag-cure-44'
      }, {
        name: 'Bord abîmé - Simple',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        id: '13.bag-cure-45'
      }, {
        name: 'Bord abîmé - Complexe',
        prices: {
          SIMPLE: 70,
          COMPLEX: 70
        },
        id: '13.bag-cure-46'
      }, {
        name: 'Couture décousue (0 à 5 cm)',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.bag-cure-47'
      }, {
        name: 'Couture décousue (5 à 10 cm)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.bag-cure-48',
        atShop: true
      }, {
        name: 'Couture décousue (10 à 40 cm)',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        id: '13.bag-cure-49'
      }, {
        name: 'Couture décousue (> 40 cm)',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: '13.bag-cure-50'
      }, {
        name: 'Couture décousue - Main / sellier - Simple',
        prices: {
          SIMPLE: 25,
          COMPLEX: 25
        },
        id: '13.bag-cure-51'
      }, {
        name: 'Couture décousue - Main / sellier - Standard',
        prices: {
          SIMPLE: 50,
          COMPLEX: 50
        },
        id: '13.bag-cure-63'
      }, {
        name: 'Couture décousue - Main / sellier - Complexe',
        prices: {
          SIMPLE: 100,
          COMPLEX: 100
        },
        id: '13.bag-cure-64'
      },
      // DEPRECATED
      {
        name: 'Craquelure / éraflure : raccord couleur',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.bag-cure-1',
        hidden: true
      }, {
        name: 'Déchirure : réparation avec pose d‘empiècement',
        prices: {
          SIMPLE: 60
        },
        multiple: true,
        id: '13.bag-cure-3',
        hidden: true
      }, {
        name: 'Déchirure : réparation avec changement de panneau (petit)',
        prices: {
          SIMPLE: 90
        },
        multiple: true,
        id: '13.bag-cure-4',
        hidden: true
      }, {
        name: 'Déchirure : réparation avec changement de panneau (moyen)',
        prices: {
          SIMPLE: 120
        },
        multiple: true,
        id: '13.bag-cure-5',
        hidden: true
      }, {
        name: 'Déchirure : réparation avec changement de panneau (grand)',
        prices: {
          SIMPLE: 150
        },
        multiple: true,
        id: '13.bag-cure-6',
        hidden: true
      }, {
        name: 'Déchirure : réparation avec changement de panneau (complex)',
        prices: {
          SIMPLE: 180
        },
        multiple: true,
        id: '13.bag-cure-7',
        hidden: true
      }]
    }, {
      name: 'Anses & bandoulières',
      slug: 'handles',
      items: [{
        name: 'Bandoulière en cuir - Changement intégral (simple)',
        prices: {
          SIMPLE: 90,
          COMPLEX: 90
        },
        id: '13.bag-cure-53'
      }, {
        name: 'Bandoulière en cuir - Changement intégral (double face)',
        prices: {
          SIMPLE: 150,
          COMPLEX: 150
        },
        id: '13.bag-cure-54'
      }, {
        name: 'Bandoulière en toile ou en métal - Changement intégral',
        prices: {
          SIMPLE: 70,
          COMPLEX: 70
        },
        id: '13.bag-cure-55'
      }, {
        name: 'Enchape - Réparation x1',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        id: '13.bag-cure-57'
      }, {
        name: 'Anse / poignée - Rénovation (x2)',
        prices: {
          SIMPLE: 70,
          COMPLEX: 70
        },
        id: '13.bag-cure-58',
        atShop: true
      }, {
        name: 'Anse / poignée - Changement complet (x2)',
        prices: {
          SIMPLE: 150,
          COMPLEX: 150
        },
        id: '13.bag-cure-59'
      }, {
        name: 'Poignée ronde (couture main) - Rénovation (x2)',
        prices: {
          SIMPLE: 110,
          COMPLEX: 110
        },
        id: '13.bag-cure-60'
      }, {
        name: 'Poignée ronde (couture main) - Changement complet (x2)',
        prices: {
          SIMPLE: 220,
          COMPLEX: 220
        },
        id: '13.bag-cure-61'
      },
      // DEPRECATED
      {
        name: 'Bandoulière en cuir - Rénovation',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: '13.bag-cure-52',
        hidden: true
      }, {
        name: 'Bandoulière / anse / poignée / biais - Changement simple (x1)',
        prices: {
          SIMPLE: 50
        },
        id: '13.bag-cure-11',
        hidden: true
      }, {
        name: 'Bandoulière / anse / poignée / biais - Changement standard (x1)',
        prices: {
          SIMPLE: 70
        },
        id: '13.bag-cure-12',
        hidden: true
      }, {
        name: 'Bandoulière / anse / poignée / biais - Changement complexe (x1)',
        prices: {
          SIMPLE: 100
        },
        id: '13.bag-cure-13',
        hidden: true
      }, {
        name: 'Renfort intérieur - Changement simple (x1 empiècement) ',
        prices: {
          SIMPLE: 30
        },
        id: '13.bag-cure-18',
        hidden: true
      }, {
        name: 'Renfort intérieur - Changement complexe (x1 empiècement) ',
        prices: {
          SIMPLE: 50
        },
        id: '13.bag-cure-19',
        hidden: true
      }, {
        name: 'Bandoulière / anse / poignée - Changement métallique (x1)',
        prices: {
          SIMPLE: 40
        },
        id: '13.bag-cure-20',
        hidden: true
      }]
    }, {
      name: 'Doublure',
      slug: 'lining',
      items: [{
        name: 'Doublure - Changement partiel',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: '13.bag-cure-14'
      }, {
        name: 'Doublure - Changement intégral - Simple',
        prices: {
          SIMPLE: 90,
          COMPLEX: 90
        },
        id: '13.bag-cure-15',
        atShop: true
      }, {
        name: 'Doublure - Changement intégral - Standard',
        prices: {
          SIMPLE: 140,
          COMPLEX: 140
        },
        id: '13.bag-cure-16'
      }, {
        name: 'Doublure - Changement intégral - Complexe',
        prices: {
          SIMPLE: 180,
          COMPLEX: 180
        },
        id: '13.bag-cure-17'
      }]
    }, {
      name: 'Zips & pièces métalliques',
      slug: 'zips_metal',
      items: [].concat(_toConsumableArray((0, _commonPricings.getCommunZipsRepair)({
        slug: 'bag'
      }).items.map(function (_ref) {
        var repairBonus = _ref.repairBonus,
          item = _objectWithoutProperties(_ref, _excluded);
        return _objectSpread({}, item);
      })), [{
        name: 'Zip - Changement simple',
        prices: {
          SIMPLE: 80,
          COMPLEX: 80
        },
        multiple: true,
        id: '13.bag-cure-21',
        atShop: true
      }, {
        name: 'Zip - Changement simple fourni par le client',
        prices: {
          SIMPLE: 70,
          COMPLEX: 70
        },
        multiple: true,
        id: '13.bag-cure-22'
      }, {
        name: 'Zip - Changement standard',
        prices: {
          SIMPLE: 100,
          COMPLEX: 100
        },
        multiple: true,
        id: '13.bag-cure-23'
      }, {
        name: 'Zip - Changement standard fourni par le client',
        prices: {
          SIMPLE: 90,
          COMPLEX: 90
        },
        multiple: true,
        id: '13.bag-cure-24'
      }, {
        name: 'Zip - Changement complexe',
        prices: {
          SIMPLE: 150,
          COMPLEX: 150
        },
        multiple: true,
        id: '13.bag-cure-25'
      }, {
        name: 'Zip - Changement complexe fourni par le client',
        prices: {
          SIMPLE: 140,
          COMPLEX: 140
        },
        multiple: true,
        id: '13.bag-cure-26'
      }, {
        name: 'Boutons pression / rivet / oeillet (x1 bouton)',
        prices: {
          SIMPLE: 8,
          COMPLEX: 8
        },
        multiple: true,
        id: '13.bag-cure-31',
        atShop: true
      }, {
        name: 'Boutons pression / rivet / oeillet (x1 bouton suppl.)',
        prices: {
          SIMPLE: 2,
          COMPLEX: 2
        },
        multiple: true,
        id: '13.bag-cure-62'
      }, {
        name: 'Fermoir - Changement simple (aimant / pression / mousqueton)',
        prices: {
          SIMPLE: 40,
          COMPLEX: 40
        },
        id: '13.bag-cure-33'
      }, {
        name: 'Fermoir - Changement simple (aimant / pression / mousqueton) fourni par le client',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        id: '13.bag-cure-34'
      }, {
        name: 'Fermoir - Changement complexe (fermoir tourniquet et autres boucles)',
        prices: {
          SIMPLE: 60,
          COMPLEX: 60
        },
        id: '13.bag-cure-35'
      }, {
        name: 'Fermoir - Changement complexe (fermoir tourniquet et autres boucles) fourni par le client',
        prices: {
          SIMPLE: 50,
          COMPLEX: 50
        },
        id: '13.bag-cure-36'
      }, {
        name: 'Autre pièce métallique (crochet / boucle)',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        multiple: true,
        id: '13.bag-cure-37'
      }, {
        name: 'Autre pièce métallique (crochet / boucle) fourni par le client',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        multiple: true,
        id: '13.bag-cure-38'
      }, {
        name: 'Curseur',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        multiple: true,
        id: '13.bag-cure-65'
      }, {
        name: 'Curseur fourni par le client',
        prices: {
          SIMPLE: 13,
          COMPLEX: 13
        },
        multiple: true,
        id: '13.bag-cure-66'
      }, {
        name: 'Tirette de curseur',
        prices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        multiple: true,
        id: '13.bag-cure-67'
      }, {
        name: 'Tirette de curseur fourni par le client',
        prices: {
          SIMPLE: 4,
          COMPLEX: 4
        },
        multiple: true,
        id: '13.bag-cure-68'
      }])
    }]
  }, communLeatherGoodsFinish('bag')]
}, _objectSpread({
  name: 'Portefeuille & Pochette',
  slug: 'wallet',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }]
}, generateLeatherGoodsAccePrice('wallet')), _objectSpread({
  name: 'Ceinture',
  slug: 'belt',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }]
}, generateLeatherGoodsAccePrice('belt')), {
  name: 'Chaussures',
  slug: 'shoes',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Prise en charge',
    slug: 'receiving',
    items: [{
      name: 'Prise en charge - Chaussures plates',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '13.shoes-receiving-1'
    }, {
      name: 'Prise en charge - Chaussures à talon',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '13.shoes-receiving-2'
    }, {
      name: 'Prise en charge - Sneakers',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '13.shoes-receiving-3'
    }, {
      name: 'Prise en charge - Bottes / Bottines plates',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '13.shoes-receiving-4'
    }, {
      name: 'Prise en charge - Bottes / Bottines à talon',
      prices: {
        SIMPLE: 0,
        COMPLEX: 0
      },
      id: '13.shoes-receiving-5'
    }]
  }, {
    name: 'Entretenir',
    slug: 'prevent',
    subCategories: [{
      name: 'Soin du cuir',
      slug: 'leather_care',
      items: [{
        name: 'Entretien (nettoyage & cirage)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 29
        },
        id: '13.shoes-prevent-1'
      }, {
        name: 'Entretien (nettoyage & cirage) - Bottines / Bottes',
        prices: {
          SIMPLE: 35,
          COMPLEX: 39
        },
        id: '13.shoes-prevent-2'
      },
      // Same price textile, leather, suede
      {
        name: 'Entretien (nettoyage & cirage) - Sneakers',
        prices: {
          SIMPLE: 29,
          COMPLEX: 29
        },
        id: '13.shoes-prevent-3'
      }, {
        name: 'Entretien (nettoyage & cirage) - Supplément semelle',
        prices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '13.shoes-prevent-14'
      }, {
        name: 'Cirage simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.shoes-prevent-15'
      }, {
        name: 'Cirage & Glaçage',
        prices: {
          SIMPLE: 29,
          COMPLEX: 29
        },
        id: '13.shoes-prevent-4'
      }, {
        name: 'Rénovation complète',
        prices: {
          SIMPLE: 55,
          COMPLEX: 59
        },
        id: '13.shoes-prevent-5'
      }, {
        name: 'Rénovation complète - Sneakers',
        prices: {
          SIMPLE: 55,
          COMPLEX: 55
        },
        id: '13.shoes-prevent-6'
      }, {
        name: 'Rénovation complète - Bottes',
        prices: {
          SIMPLE: 65,
          COMPLEX: 65
        },
        id: '13.shoes-prevent-7'
      }, {
        name: 'Changement de lacets',
        prices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '13.shoes-prevent-16'
      }]
    }, {
      name: 'Protéger (patins & fer)',
      slug: 'protect',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.shoes-prevent-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Pose de fers (x2)',
        prices: {
          SIMPLE: 21,
          COMPLEX: 21
        },
        id: '13.shoes-prevent-12',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Protection complète - Patins & fers (x2)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        id: '13.shoes-prevent-13',
        repairBonus: 'SHOE_OVERSHOE_AND_SEWING'
      }]
    }, {
      name: 'Agrandir',
      slug: 'stretch',
      items: [{
        name: 'Mise en forme - Largeur',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.shoes-prevent-8'
      }, {
        name: 'Mise en forme - Coup de pied',
        prices: {
          SIMPLE: 29,
          COMPLEX: 29
        },
        id: '13.shoes-prevent-9'
      }, {
        name: 'Mise en forme - Mollet (bottine ou botte)',
        prices: {
          SIMPLE: 29,
          COMPLEX: 29
        },
        id: '13.shoes-prevent-10'
      }]
    }]
  }, {
    name: 'Réparer',
    slug: 'cure',
    subCategories: [{
      name: 'Semelle',
      slug: 'sole',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.shoes-cure-30',
        repairBonus: 'SHOE_OVERSHOE',
        onlyCouturiers: true
      }, {
        name: 'Ressemelage - Collé Caoutchouc - Semelle complète',
        prices: {
          SIMPLE: 83,
          COMPLEX: 83
        },
        id: '13.shoes-cure-1',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Ressemelage - Collé Caoutchouc - Demi semelle',
        prices: {
          SIMPLE: 78,
          COMPLEX: 78
        },
        id: '13.shoes-cure-24',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Ressemelage - Collé Cuir - Semelle complète',
        prices: {
          SIMPLE: 110,
          COMPLEX: 110
        },
        id: '13.shoes-cure-2',
        repairBonus: 'SHOE_RESOLE_LEATHER'
      }, {
        name: 'Ressemelage - Collé Cuir - Demi semelle',
        prices: {
          SIMPLE: 85,
          COMPLEX: 85
        },
        id: '13.shoes-cure-25',
        repairBonus: 'SHOE_RESOLE_LEATHER'
      }, {
        name: 'Ressemelage - Sneakers',
        prices: {
          SIMPLE: 70,
          COMPLEX: 70
        },
        id: '13.shoes-cure-3',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Ressemelage - Cousu rainette - Semelle complète',
        prices: {
          SIMPLE: 130,
          COMPLEX: 130
        },
        id: '13.shoes-cure-4',
        repairBonus: 'SHOE_RESOLE_LEATHER'
      }, {
        name: 'Ressemelage - Cousu rainette - Demi semelle',
        prices: {
          SIMPLE: 90,
          COMPLEX: 90
        },
        id: '13.shoes-cure-26',
        repairBonus: 'SHOE_RESOLE_LEATHER'
      }, {
        name: 'Ressemelage - Cousu sous gravure',
        prices: {
          SIMPLE: 175,
          COMPLEX: 175
        },
        id: '13.shoes-cure-5',
        repairBonus: 'SHOE_RESOLE_LEATHER'
      }, {
        name: 'Ressemelage - Birkenstock',
        prices: {
          SIMPLE: 54,
          COMPLEX: 54
        },
        id: '13.shoes-cure-6',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Recollage semelle',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        multiple: true,
        id: '13.shoes-cure-23',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Semelle intérieure - Demi',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.shoes-cure-13'
      }, {
        name: 'Semelle intérieure - Complète',
        prices: {
          SIMPLE: 22,
          COMPLEX: 22
        },
        id: '13.shoes-cure-14'
      }]
    }, {
      name: 'Bonbout / talon',
      slug: 'cap_heel',
      items: [{
        name: 'Bonbout (changement) - Chaussures à talon plat - Caoutchouc',
        prices: {
          SIMPLE: 24,
          COMPLEX: 24
        },
        id: '13.shoes-cure-7',
        repairBonus: 'SHOE_CAP'
      }, {
        name: 'Bonbout (changement) - Chaussures à talon plat - Cuir + caoutchouc',
        prices: {
          SIMPLE: 29,
          COMPLEX: 29
        },
        id: '13.shoes-cure-8',
        repairBonus: 'SHOE_CAP'
      }, {
        name: 'Bonbout (changement) - Talons aiguille',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.shoes-cure-9',
        repairBonus: 'SHOE_CAP'
      }, {
        name: 'Talon complet (changement) - Chaussures plates',
        prices: {
          SIMPLE: 65,
          COMPLEX: 65
        },
        id: '13.shoes-cure-10',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Enveloppe talon (changement) - Chaussures à talons',
        prices: {
          SIMPLE: 55,
          COMPLEX: 55
        },
        id: '13.shoes-cure-11',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Redresse talon - Chaussures plates',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.shoes-cure-12',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Glissoirs',
      slug: 'slides',
      items: [{
        name: 'Glissoirs (changement)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        id: '13.shoes-cure-15',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Glissoirs boots (changement)',
        prices: {
          SIMPLE: 50,
          COMPLEX: 50
        },
        id: '13.shoes-cure-16',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Déchirures / trous',
      slug: 'tears',
      items: [{
        name: 'Redresse (avant / arrière x1)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.shoes-cure-31',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Trou (rustine intérieure)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        multiple: true,
        id: '13.shoes-cure-27',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Couture décousue',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.shoes-cure-28',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Point de colle',
        prices: {
          SIMPLE: 14,
          COMPLEX: 14
        },
        multiple: true,
        id: '13.shoes-cure-29',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Zips & pièces métalliques',
      slug: 'zips_metal',
      items: [{
        name: 'Zip - Changement (x1)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        multiple: true,
        id: '13.shoes-cure-17',
        repairBonus: 'SHOE_ZIP_SMALL'
      }, {
        name: 'Zip de bottes - Changement (x1)',
        prices: {
          SIMPLE: 55,
          COMPLEX: 55
        },
        multiple: true,
        id: '13.shoes-cure-18',
        repairBonus: 'SHOE_ZIP_BIG'
      }, {
        name: 'Boutons pression / œillets / rivets (x1)',
        prices: {
          SIMPLE: 11,
          COMPLEX: 11
        },
        multiple: true,
        id: '13.shoes-cure-19'
      }, {
        name: 'Boucle - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.shoes-cure-20',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Élastique / scratch - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.shoes-cure-21',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boucle avec élastique - Changement (x1)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        multiple: true,
        id: '13.shoes-cure-22',
        repairBonus: 'SHOE_SEWING'
      }]
    }]
  }, {
    name: 'Finition',
    slug: 'finish',
    items: [{
      name: 'Finition supplémentaire - Simple',
      prices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      id: '13.shoes-finish-1'
    }, {
      name: 'Finition supplémentaire - Standard',
      prices: {
        SIMPLE: 10,
        COMPLEX: 10
      },
      id: '13.shoes-finish-2'
    }, {
      name: 'Finition supplémentaire - Complexe',
      prices: {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: '13.shoes-finish-3'
    }]
  }]
}, {
  name: 'Chaussures Plates',
  slug: 'flat_shoes',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Entretenir',
    slug: 'prevent',
    subCategories: [{
      name: 'Protéger',
      slug: 'protect',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.flat-shoes-prevent-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Pose de fers (x2)',
        prices: {
          SIMPLE: 21,
          COMPLEX: 21
        },
        id: '13.flat-shoes-prevent-12',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Protection complète - Patins & fers (x2)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        id: '13.flat-shoes-prevent-13',
        repairBonus: 'SHOE_OVERSHOE_AND_SEWING'
      }]
    }, {
      name: 'Nettoyer et cirer',
      slug: 'wash_and_sew',
      items: [{
        name: 'Entretien (nettoyage & cirage)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 29
        },
        id: '13.flat-shoes-prevent-1'
      }, {
        name: 'Rénovation complète',
        prices: {
          SIMPLE: 55,
          COMPLEX: 59
        },
        id: '13.flat-shoes-prevent-5'
      }, {
        name: 'Cirage simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.flat-shoes-prevent-4'
      }, {
        name: 'Changement de lacets',
        prices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '13.flat-shoes-prevent-8'
      }]
    }
    // {
    //   name: 'Mise en forme',
    //   slug: 'shape',
    //   items: [
    //     { name: 'Mise en forme - Largeur', prices: { SIMPLE: 15, COMPLEX: 15 }, id: '13.flat-shoes-prevent-8' },
    //     { name: 'Mise en forme - Coup de pied', prices: { SIMPLE: 29, COMPLEX: 29 }, id: '13.flat-shoes-prevent-9' },
    //   ],
    // },
    ]
  }, {
    name: 'Réparer',
    slug: 'cure',
    subCategories: [{
      name: 'Semelle',
      slug: 'damagedSole',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.flat-shoes-prevent-cure-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Ressemelage - Collé Caoutchouc - Semelle complète',
        prices: {
          SIMPLE: 83,
          COMPLEX: 83
        },
        id: '13.flat-shoes-cure-1',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Ressemelage - Collé Caoutchouc - Demi semelle',
        prices: {
          SIMPLE: 78,
          COMPLEX: 78
        },
        id: '13.flat-shoes-cure-24',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Recollage semelle',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        multiple: true,
        id: '13.flat-shoes-cure-23',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Talon',
      slug: 'damagedHeel',
      items: [{
        name: 'Bonbout (changement) - Chaussures à talon plat - Caoutchouc',
        prices: {
          SIMPLE: 24,
          COMPLEX: 24
        },
        id: '13.flat-shoes-cure-7',
        repairBonus: 'SHOE_CAP'
      }, {
        name: 'Talon complet (changement) - Chaussures plates',
        prices: {
          SIMPLE: 65,
          COMPLEX: 65
        },
        id: '13.flat-shoes-cure-10',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Redresse talon - Chaussures plates',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.flat-shoes-cure-12',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: "À l'intérieur",
      slug: 'damagedInside',
      items: [{
        name: 'Semelle intérieure - Demi',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.flat-shoes-cure-13'
      }, {
        name: 'Semelle intérieure - Complète',
        prices: {
          SIMPLE: 22,
          COMPLEX: 22
        },
        id: '13.flat-shoes-cure-14'
      }, {
        name: 'Glissoirs (changement)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        id: '13.flat-shoes-cure-15',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Autre (zips, boucles, trou)',
      slug: 'damagedOther',
      items: [{
        name: 'Zip - Changement (x1)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        multiple: true,
        id: '13.flat-shoes-cure-17',
        repairBonus: 'SHOE_ZIP_SMALL'
      }, {
        name: 'Trou (rustine intérieure)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        multiple: true,
        id: '13.flat-shoes-cure-27',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boutons pression / œillets / rivets (x1)',
        prices: {
          SIMPLE: 11,
          COMPLEX: 11
        },
        multiple: true,
        id: '13.flat-shoes-cure-19'
      }, {
        name: 'Boucle - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.flat-shoes-cure-20',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Élastique / scratch - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.flat-shoes-cure-21',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boucle avec élastique - Changement (x1)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        multiple: true,
        id: '13.flat-shoes-cure-22',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Redresse (avant / arrière x1)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.flat-shoes-cure-31',
        repairBonus: 'SHOE_SEWING'
      }]
    }]
  }]
}, {
  name: 'Chaussures à talon',
  slug: 'heeled_shoes',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Entretenir',
    slug: 'prevent',
    subCategories: [{
      name: 'Protéger',
      slug: 'protect',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.heeled-shoes-prevent-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Pose de fers (x2)',
        prices: {
          SIMPLE: 21,
          COMPLEX: 21
        },
        id: '13.heeled-shoes-prevent-12',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Protection complète - Patins & fers (x2)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        id: '13.heeled-shoes-prevent-13',
        repairBonus: 'SHOE_OVERSHOE_AND_SEWING'
      }]
    }, {
      name: 'Nettoyer et cirer',
      slug: 'wash_and_sew',
      items: [{
        name: 'Entretien (nettoyage & cirage)',
        prices: {
          SIMPLE: 25,
          COMPLEX: 29
        },
        id: '13.heeled-shoes-prevent-1'
      }, {
        name: 'Rénovation complète',
        prices: {
          SIMPLE: 55,
          COMPLEX: 59
        },
        id: '13.heeled-shoes-prevent-5'
      }, {
        name: 'Cirage simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.heeled-shoes-prevent-4'
      }, {
        name: 'Changement de lacets',
        prices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '13.heeled-shoes-prevent-8'
      }]
    }
    // {
    //   name: 'Mise en forme',
    //   slug: 'shape',
    //   items: [
    //     { name: 'Mise en forme - Largeur', prices: { SIMPLE: 15, COMPLEX: 15 }, id: '13.heeled-shoes-prevent-8' },
    //     { name: 'Mise en forme - Coup de pied', prices: { SIMPLE: 29, COMPLEX: 29 }, id: '13.heeled-shoes-prevent-9' },
    //   ],
    // },
    ]
  }, {
    name: 'Réparer',
    slug: 'cure',
    subCategories: [{
      name: 'Semelle',
      slug: 'damagedSole',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.heeled-shoes-prevent-cure-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Ressemelage - Collé Caoutchouc - Semelle complète',
        prices: {
          SIMPLE: 83,
          COMPLEX: 83
        },
        id: '13.heeled-shoes-cure-1',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Ressemelage - Collé Caoutchouc - Demi semelle',
        prices: {
          SIMPLE: 78,
          COMPLEX: 78
        },
        id: '13.heeled-shoes-cure-24',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Recollage semelle',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        multiple: true,
        id: '13.heeled-shoes-cure-23',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Talon',
      slug: 'damagedHeel',
      items: [{
        name: 'Bonbout (changement) - Caoutchouc',
        prices: {
          SIMPLE: 24,
          COMPLEX: 24
        },
        id: '13.heeled-shoes-cure-7',
        repairBonus: 'SHOE_CAP'
      }, {
        name: 'Bonbout (changement) - Talons aiguille',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.heeled-shoes-cure-9',
        repairBonus: 'SHOE_CAP'
      }, {
        name: 'Talon complet (changement)',
        prices: {
          SIMPLE: 65,
          COMPLEX: 65
        },
        id: '13.heeled-shoes-cure-10',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Enveloppe talon (changement) - Chaussures à talons',
        prices: {
          SIMPLE: 55,
          COMPLEX: 55
        },
        id: '13.heeled-shoes-cure-11',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Redresse talon',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.heeled-shoes-cure-12',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: "À l'intérieur",
      slug: 'damagedInside',
      items: [{
        name: 'Semelle intérieure - Demi',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.heeled-shoes-cure-13'
      }, {
        name: 'Semelle intérieure - Complète',
        prices: {
          SIMPLE: 22,
          COMPLEX: 22
        },
        id: '13.heeled-shoes-cure-14'
      }, {
        name: 'Glissoirs (changement)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        id: '13.heeled-shoes-cure-15',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Autre (zips, boucles, trou)',
      slug: 'damagedOther',
      items: [{
        name: 'Zip - Changement (x1)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        multiple: true,
        id: '13.heeled-shoes-cure-17',
        repairBonus: 'SHOE_ZIP_SMALL'
      }, {
        name: 'Trou (rustine intérieure)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        multiple: true,
        id: '13.heeled-shoes-cure-27',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boutons pression / œillets / rivets (x1)',
        prices: {
          SIMPLE: 11,
          COMPLEX: 11
        },
        multiple: true,
        id: '13.heeled-shoes-cure-19'
      }, {
        name: 'Boucle - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.heeled-shoes-cure-20',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Élastique / scratch - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.heeled-shoes-cure-21',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boucle avec élastique - Changement (x1)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        multiple: true,
        id: '13.heeled-shoes-cure-22',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Redresse (avant / arrière x1)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.heeled-shoes-cure-31',
        repairBonus: 'SHOE_SEWING'
      }]
    }]
  }]
}, {
  name: 'Bottes / Bottines plates',
  slug: 'boots',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Entretenir',
    slug: 'prevent',
    subCategories: [{
      name: 'Protéger',
      slug: 'protect',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.boots-prevent-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Pose de fers (x2)',
        prices: {
          SIMPLE: 21,
          COMPLEX: 21
        },
        id: '13.boots-prevent-12',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Protection complète - Patins & fers (x2)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        id: '13.boots-prevent-13',
        repairBonus: 'SHOE_OVERSHOE_AND_SEWING'
      }]
    }, {
      name: 'Nettoyer et cirer',
      slug: 'wash_and_sew',
      items: [{
        name: 'Entretien (nettoyage & cirage) - Bottes',
        prices: {
          SIMPLE: 35,
          COMPLEX: 39
        },
        id: '13.boots-prevent-2'
      }, {
        name: 'Rénovation complète - Bottes',
        prices: {
          SIMPLE: 65,
          COMPLEX: 65
        },
        id: '13.boots-prevent-7'
      }, {
        name: 'Cirage simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.boots-prevent-4'
      }, {
        name: 'Changement de lacets',
        prices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '13.boots-prevent-8'
      }]
    }
    // {
    //   name: 'Mise en forme',
    //   slug: 'shape',
    //   items: [
    //     { name: 'Mise en forme - Largeur', prices: { SIMPLE: 15, COMPLEX: 15 }, id: '13.boots-prevent-8' },
    //     { name: 'Mise en forme - Coup de pied', prices: { SIMPLE: 29, COMPLEX: 29 }, id: '13.boots-prevent-9' },
    //     { name: 'Mise en forme - Mollet (bottine ou botte)', prices: { SIMPLE: 29, COMPLEX: 29 }, id: '13.boots-prevent-10' },
    //   ],
    // },
    ]
  }, {
    name: 'Réparer',
    slug: 'cure',
    subCategories: [{
      name: 'Semelle',
      slug: 'damagedSole',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.boots-prevent-cure-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Ressemelage - Collé Caoutchouc - Semelle complète',
        prices: {
          SIMPLE: 83,
          COMPLEX: 83
        },
        id: '13.boots-cure-1',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Ressemelage - Collé Caoutchouc - Demi semelle',
        prices: {
          SIMPLE: 78,
          COMPLEX: 78
        },
        id: '13.boots-cure-24',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Recollage semelle',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        multiple: true,
        id: '13.boots-cure-23',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Talon',
      slug: 'damagedHeel',
      items: [{
        name: 'Bonbout (changement) - Caoutchouc',
        prices: {
          SIMPLE: 24,
          COMPLEX: 24
        },
        id: '13.boots-cure-7',
        repairBonus: 'SHOE_CAP'
      }, {
        name: 'Talon complet (changement) ',
        prices: {
          SIMPLE: 65,
          COMPLEX: 65
        },
        id: '13.boots-cure-10',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Redresse talon ',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.boots-cure-12',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: "À l'intérieur",
      slug: 'damagedInside',
      items: [{
        name: 'Semelle intérieure - Demi',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.boots-cure-13'
      }, {
        name: 'Semelle intérieure - Complète',
        prices: {
          SIMPLE: 22,
          COMPLEX: 22
        },
        id: '13.boots-cure-14'
      }, {
        name: 'Glissoirs bottes (changement)',
        prices: {
          SIMPLE: 50,
          COMPLEX: 50
        },
        id: '13.boots-cure-16',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Autre (zips, boucles, trou)',
      slug: 'damagedOther',
      items: [{
        name: 'Zip de bottes - Changement (x1)',
        prices: {
          SIMPLE: 55,
          COMPLEX: 55
        },
        multiple: true,
        id: '13.boots-cure-18',
        repairBonus: 'SHOE_ZIP_BIG'
      }, {
        name: 'Trou (rustine intérieure)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        multiple: true,
        id: '13.boots-cure-27',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boutons pression / œillets / rivets (x1)',
        prices: {
          SIMPLE: 11,
          COMPLEX: 11
        },
        multiple: true,
        id: '13.boots-cure-19'
      }, {
        name: 'Boucle - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.boots-cure-20',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Élastique / scratch - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.boots-cure-21',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boucle avec élastique - Changement (x1)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        multiple: true,
        id: '13.boots-cure-22',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Redresse (avant / arrière x1)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.boots-cure-31',
        repairBonus: 'SHOE_SEWING'
      }]
    }]
  }]
}, {
  name: 'Bottes / Bottines à talon',
  slug: 'heeled_boots',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Entretenir',
    slug: 'prevent',
    subCategories: [{
      name: 'Protéger',
      slug: 'protect',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.heeled-boots-prevent-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Pose de fers (x2)',
        prices: {
          SIMPLE: 21,
          COMPLEX: 21
        },
        id: '13.heeled-boots-prevent-12',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Protection complète - Patins & fers (x2)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        id: '13.heeled-boots-prevent-13',
        repairBonus: 'SHOE_OVERSHOE_AND_SEWING'
      }]
    }, {
      name: 'Nettoyer et cirer',
      slug: 'wash_and_sew',
      items: [{
        name: 'Entretien (nettoyage & cirage) - Bottes',
        prices: {
          SIMPLE: 35,
          COMPLEX: 39
        },
        id: '13.heeled-boots-prevent-2'
      }, {
        name: 'Rénovation complète - Bottes',
        prices: {
          SIMPLE: 65,
          COMPLEX: 65
        },
        id: '13.heeled-boots-prevent-7'
      }, {
        name: 'Cirage simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.heeled-boots-prevent-4'
      }, {
        name: 'Changement de lacets',
        prices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '13.heeled-boots-prevent-8'
      }]
    }
    // {
    //   name: 'Mise en forme',
    //   slug: 'shape',
    //   items: [
    //     { name: 'Mise en forme - Largeur', prices: { SIMPLE: 15, COMPLEX: 15 }, id: '13.heeled-boots-prevent-8' },
    //     { name: 'Mise en forme - Coup de pied', prices: { SIMPLE: 29, COMPLEX: 29 }, id: '13.heeled-boots-prevent-9' },
    //     { name: 'Mise en forme - Mollet (bottine ou botte)', prices: { SIMPLE: 29, COMPLEX: 29 }, id: '13.heeled-boots-prevent-10' },
    //   ],
    // },
    ]
  }, {
    name: 'Réparer',
    slug: 'cure',
    subCategories: [{
      name: 'Semelle',
      slug: 'damagedSole',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.heeled-boots-prevent-cure-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Ressemelage - Collé Caoutchouc - Semelle complète',
        prices: {
          SIMPLE: 83,
          COMPLEX: 83
        },
        id: '13.heeled-boots-cure-1',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Ressemelage - Collé Caoutchouc - Demi semelle',
        prices: {
          SIMPLE: 78,
          COMPLEX: 78
        },
        id: '13.heeled-boots-cure-24',
        repairBonus: 'SHOE_RESOLE_RUBBER'
      }, {
        name: 'Recollage semelle',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        multiple: true,
        id: '13.heeled-boots-cure-23',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Talon',
      slug: 'damagedHeel',
      items: [{
        name: 'Bonbout (changement) - Caoutchouc',
        prices: {
          SIMPLE: 24,
          COMPLEX: 24
        },
        id: '13.heeled-boots-cure-7',
        repairBonus: 'SHOE_CAP'
      }, {
        name: 'Bonbout (changement) - Talons aiguille',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.heeled-boots-cure-9',
        repairBonus: 'SHOE_CAP'
      }, {
        name: 'Talon complet (changement) ',
        prices: {
          SIMPLE: 65,
          COMPLEX: 65
        },
        id: '13.heeled-boots-cure-10',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Enveloppe talon (changement) - Chaussures à talons',
        prices: {
          SIMPLE: 55,
          COMPLEX: 55
        },
        id: '13.heeled-boots-cure-11',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Redresse talon ',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.heeled-boots-cure-12',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: "À l'intérieur",
      slug: 'damagedInside',
      items: [{
        name: 'Semelle intérieure - Demi',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.heeled-boots-cure-13'
      }, {
        name: 'Semelle intérieure - Complète',
        prices: {
          SIMPLE: 22,
          COMPLEX: 22
        },
        id: '13.heeled-boots-cure-14'
      }, {
        name: 'Glissoirs bottes (changement)',
        prices: {
          SIMPLE: 50,
          COMPLEX: 50
        },
        id: '13.heeled-boots-cure-16',
        repairBonus: 'SHOE_SEWING'
      }]
    }, {
      name: 'Autre (zips, boucles, trou)',
      slug: 'damagedOther',
      items: [{
        name: 'Zip de bottes - Changement (x1)',
        prices: {
          SIMPLE: 55,
          COMPLEX: 55
        },
        multiple: true,
        id: '13.heeled-boots-cure-18',
        repairBonus: 'SHOE_ZIP_BIG'
      }, {
        name: 'Trou (rustine intérieure)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        multiple: true,
        id: '13.heeled-boots-cure-27',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boutons pression / œillets / rivets (x1)',
        prices: {
          SIMPLE: 11,
          COMPLEX: 11
        },
        multiple: true,
        id: '13.heeled-boots-cure-19'
      }, {
        name: 'Boucle - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.heeled-boots-cure-20',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Élastique / scratch - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.heeled-boots-cure-21',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boucle avec élastique - Changement (x1)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        multiple: true,
        id: '13.heeled-boots-cure-22',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Redresse (avant / arrière x1)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.heeled-boots-cure-31',
        repairBonus: 'SHOE_SEWING'
      }]
    }]
  }]
}, {
  name: 'Sneakers',
  slug: 'sneakers',
  hasMostCommonCategory: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Entretenir',
    slug: 'prevent',
    subCategories: [{
      name: 'Nettoyer et cirer',
      slug: 'wash_and_sew',
      items: [{
        name: 'Entretien (nettoyage & cirage) - Sneakers',
        prices: {
          SIMPLE: 29,
          COMPLEX: 29
        },
        id: '13.sneakers-prevent-3',
        infoPreview: [{
          label: 'Hors intérieur et semelle'
        }]
      }, {
        name: 'Rénovation complète - Sneakers',
        prices: {
          SIMPLE: 55,
          COMPLEX: 55
        },
        id: '13.sneakers-prevent-6',
        infoPreview: [{
          label: 'Extérieur, intérieur et semelle inclus'
        }]
      }, {
        name: 'Cirage simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: '13.sneakers-prevent-4'
      }, {
        name: 'Changement de lacets',
        prices: {
          SIMPLE: 5,
          COMPLEX: 5
        },
        id: '13.sneakers-prevent-7'
      }]
    }, {
      name: 'Protéger',
      slug: 'protect',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.sneakers-prevent-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Pose de fers (x2)',
        prices: {
          SIMPLE: 21,
          COMPLEX: 21
        },
        id: '13.sneakers-prevent-12',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Protection complète - Patins & fers (x2)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        id: '13.sneakers-prevent-13',
        repairBonus: 'SHOE_OVERSHOE_AND_SEWING'
      }]
    }
    // {
    //   name: 'Mise en forme',
    //   slug: 'shape',
    //   items: [
    //     { name: 'Mise en forme - Largeur', prices: { SIMPLE: 15, COMPLEX: 15 }, id: '13.sneakers-prevent-8' },
    //     { name: 'Mise en forme - Coup de pied', prices: { SIMPLE: 29, COMPLEX: 29 }, id: '13.sneakers-prevent-9' },
    //   ],
    // },
    ]
  }, {
    name: 'Réparer',
    slug: 'cure',
    subCategories: [{
      name: 'Semelle',
      slug: 'damagedSole',
      items: [{
        name: 'Pose de patins (x2)',
        prices: {
          SIMPLE: 26,
          COMPLEX: 26
        },
        id: '13.sneakers-prevent-cure-11',
        repairBonus: 'SHOE_OVERSHOE'
      }, {
        name: 'Ressemelage - Sneakers',
        prices: {
          SIMPLE: 70,
          COMPLEX: 70
        },
        id: '13.sneakers-cure-3',
        repairBonus: 'SHOE_RESOLE_RUBBER',
        infoPreview: [{
          label: 'Ressemelage',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1742574793/ItemsPreview/outsoleFix_es7mod.png'
        }]
      }, {
        name: 'Recollage semelle',
        prices: {
          SIMPLE: 30,
          COMPLEX: 30
        },
        multiple: true,
        id: '13.sneakers-cure-23',
        repairBonus: 'SHOE_SEWING',
        infoPreview: [{
          label: 'Recollage semelle',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1742574793/ItemsPreview/outsoleStick_kygso8.png'
        }]
      }]
    }, {
      name: "À l'intérieur",
      slug: 'damagedInside',
      items: [{
        name: 'Semelle intérieure - Demi',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.sneakers-cure-13'
      }, {
        name: 'Semelle intérieure - Complète',
        prices: {
          SIMPLE: 22,
          COMPLEX: 22
        },
        id: '13.sneakers-cure-14',
        infoPreview: [{
          label: 'Changement semelle intérieure',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1742574793/ItemsPreview/insoleChange_y0bt8a.png'
        }]
      }, {
        name: 'Glissoirs (changement)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        id: '13.sneakers-cure-15',
        repairBonus: 'SHOE_SEWING',
        infoPreview: [{
          label: 'Avant',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1742574793/ItemsPreview/beforeShoeSlide_ucdxb5.png'
        }, {
          label: 'Après',
          picture: 'https://res.cloudinary.com/dlyzl32tm/image/upload/v1742574793/ItemsPreview/afterShoeSlide_zald41.png'
        }]
      }]
    }, {
      name: 'Autre (zips, boucles, trou)',
      slug: 'damagedOther',
      items: [{
        name: 'Zip - Changement (x1)',
        prices: {
          SIMPLE: 45,
          COMPLEX: 45
        },
        multiple: true,
        id: '13.sneakers-cure-17',
        repairBonus: 'SHOE_ZIP_SMALL'
      }, {
        name: 'Trou (rustine intérieure)',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        multiple: true,
        id: '13.sneakers-cure-27',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boutons pression / œillets / rivets (x1)',
        prices: {
          SIMPLE: 11,
          COMPLEX: 11
        },
        multiple: true,
        id: '13.sneakers-cure-19'
      }, {
        name: 'Boucle - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.sneakers-cure-20',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Élastique / scratch - Changement (x1)',
        prices: {
          SIMPLE: 19,
          COMPLEX: 19
        },
        multiple: true,
        id: '13.sneakers-cure-21',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Boucle avec élastique - Changement (x1)',
        prices: {
          SIMPLE: 35,
          COMPLEX: 35
        },
        multiple: true,
        id: '13.sneakers-cure-22',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Redresse (avant / arrière x1)',
        prices: {
          SIMPLE: 17,
          COMPLEX: 17
        },
        id: '13.sneakers-cure-31',
        repairBonus: 'SHOE_SEWING'
      }, {
        name: 'Couture décousue',
        prices: {
          SIMPLE: 20,
          COMPLEX: 20
        },
        id: '13.sneakers-cure-32',
        repairBonus: 'SHOE_SEWING'
      }]
    }]
  }]
}];
var _default = exports["default"] = rawLeatherGoodsPricing;